var _defs, _path, _path2, _rect, _path3, _rect2, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinklerStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SPRINKLER",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #SPRINKLER .cls-1 {\n        fill: #3e4346;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_180",
    "data-name": "Pfad 180",
    className: "cls-1",
    d: "M18,2A16,16,0,1,1,2,18,16.047,16.047,0,0,1,18,2m0-2A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_181",
    "data-name": "Pfad 181",
    className: "cls-1",
    d: "M21,30H15.2V25.4H13.8V21.8h8.6v3.6H21Zm-4.9-1H20V24.4h1.4V22.8H14.8v1.6h1.4V29Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_75",
    "data-name": "Rechteck 75",
    className: "cls-1",
    width: 2.3,
    height: 1.7,
    transform: "translate(16.9 19.6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_182",
    "data-name": "Pfad 182",
    className: "cls-1",
    d: "M22.2,19H13.8V17.7a4.2,4.2,0,1,1,8.4,0Zm-7.4-1h6.4v-.3a3.2,3.2,0,0,0-6.4,0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_76",
    "data-name": "Rechteck 76",
    className: "cls-1",
    width: 12.1,
    height: 1,
    transform: "translate(12 29)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_119",
    "data-name": "Gruppe 119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_183",
    "data-name": "Pfad 183",
    className: "cls-1",
    d: "M18.5,12.2h-1v-1h1Zm0-2h-1v-1h1Zm0-2h-1v-1h1Zm0-2h-1v-1h1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_120",
    "data-name": "Gruppe 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_184",
    "data-name": "Pfad 184",
    className: "cls-1",
    d: "M14.1,13.4l-.7.7-.7-.7.7-.7ZM12.7,12l-.7.7-.8-.7.7-.7Zm-1.5-1.4-.7.7-.7-.7.7-.7ZM9.8,9.1l-.7.8-.7-.8.7-.7Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_121",
    "data-name": "Gruppe 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_185",
    "data-name": "Pfad 185",
    className: "cls-1",
    d: "M23,12.7l.7.7-.7.7-.7-.7Zm1.4-1.4.7.7-.7.7-.7-.7Zm1.5-1.4.7.7-.7.7-.7-.7Zm1.4-1.5.7.7-.7.7-.7-.7Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_122",
    "data-name": "Gruppe 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_186",
    "data-name": "Pfad 186",
    className: "cls-1",
    d: "M12,17.5v1H11v-1Zm-2,0v1H9v-1Zm-2,0v1H7v-1Zm-2,0v1H5v-1Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_123",
    "data-name": "Gruppe 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_187",
    "data-name": "Pfad 187",
    className: "cls-1",
    d: "M23.9,18.7v-1h1v1Zm2,0v-1h1v1Zm2,0v-1h1v1Zm2,0v-1h1v1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinklerStep);
export default __webpack_public_path__ + "static/media/sprinkler-step.3863e3c47999f499421ba12b933c3425.svg";
export { ForwardRef as ReactComponent };